module.exports = __webpack_public_path__ + "static/img/interior.b37cdb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/interior.jpg
// module id = 0V5R
// module chunks = 0